
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { getSupabaseConfig } from '@/utils/environmentUtils';

// Get environment-appropriate configuration
const config = getSupabaseConfig();

const SUPABASE_URL = config.url;
const SUPABASE_PUBLISHABLE_KEY = config.anonKey;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);